import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  TemplateRef,
} from '@angular/core';
import { Permission } from '../../../../core/common/models/permission.model';

@Component({
  selector: 'lib-tab',
  imports: [],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  tabTitle = input.required<string>();
  tabTemplateSvgIcon = input<TemplateRef<unknown> | null>(null);
  tabDefaultIcon = input<string>('');
  tabActiveIcon = input<string>('');
  showTabTag = input<boolean>(false);
  tabTag = input<string | number | undefined>('');
  disable = input<boolean>(false);
  featurePermissions = input<string[]>([]);
  userPermissions = input<Permission[]>([]);
  active = model<boolean>(false);
  tabRoutingParam = input<string | number | undefined>('');
}
